
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.267 4c1.244 0 2.266 1.003 2.266 2.458 0 1.385-.732 2.245-2.01 2.423l-.123.014v.357l6.32 3.026c.746.357 1.236 1.121 1.277 1.976l.003.117c0 .868-.644 1.577-1.455 1.626l-.091.003H3.546C2.692 16 2 15.27 2 14.371c0-.862.458-1.649 1.18-2.042l.1-.051L9.6 9.252v-.77c0-.24.18-.434.4-.434 1.179 0 1.733-.531 1.733-1.59 0-.955-.647-1.59-1.466-1.59-.935 0-1.467.472-1.467 1.59 0 .24-.18.434-.4.434-.22 0-.4-.195-.4-.434C8 4.818 8.922 4 10.267 4zm6.944 10.41H2.788c.018.397.31.719.683.757l.075.004h12.908c.395 0 .719-.317.756-.723l.001-.038zM10 9.97l-6.395 3.063a1.416 1.416 0 00-.575.509h13.94a1.425 1.425 0 00-.476-.457l-.1-.053L10 9.97z","fill":"#303133"}})])
          )
        }
      }
    